import CreatePurchaseOrderListDrawer from './CreatePurchaseOrderListDrawerContainer';

export default CreatePurchaseOrderListDrawer;
